<template>
  <div class="info-default" 
    :style="{
        'background':`url(../../img/bet/background-${colors.theme}.png), linear-gradient(180deg, ${colors[colors.theme].from} 0%,  ${colors[colors.theme].to} 100%)`
    }">
    <div class="info-container">
      <div class="image-info">
        <div class="container-image" :class="backgroundWhite ? 'container-white' : ''">
          <img v-if="imageUrl" class="image" :src="image" alt="">
          <slot></slot>
        </div>
      </div>
      <div class="title-info" :class="backgroundWhite ? 'title-white' : ''">
        <span v-if="smallTitle" class="small-title" :style='{  
          color : colors.theme == "dark" ? "#fff" : "#000", 
          background: colors.theme == "dark" ? colors [colors.theme].to : "#fff" }
        '>{{smallTitle}}</span>
        <span class="title" :style="{ color: colors.theme == 'dark' ? '#fff' : '#000' }">{{title}}</span>
        <span class="shadow" :style='{ color : colors.theme == "dark" ? "#fff" : "#000"}'>{{title}}</span>

      </div>
      <div class="desc-info" v-if="descInfo">
        <span class="desc" :style="{ color: colors.theme == 'dark' ? '#fff' : '#000' }">{{descInfo}}</span>
      </div>
      <div class="button-info">
        <button-default 
        :style="{
          background: colors.secondary,
          padding: '25px 5px',
          'border-radius': '300px',
          'font-size': '17px'
        }" 
        :actionName="actionName" :textButton="textButton" buttonType="primary">
        </button-default>
        <div class="arrow-right"></div>
      </div>
    </div>
  </div>
</template>
<script>
import ButtonDefault from "../../buttons/ButtonDefault.vue";
export default {
  components: {
    ButtonDefault
  },
  data() {
    return {
      colors: {}
    };
  },
  created() {
    this.colors = JSON.parse(localStorage.getItem("colors"));
  },
    props: {
        imageUrl : {
            type : String,
            required : false
        },
        smallTitle : {
            type : String,
            required : false
        },
        title : {
            type : String,
            required : true
        },
        descInfo : {
            type : String
        },
        backgroundWhite : {
            type : Boolean,
            default : false
        },
        actionName : {
            type : String,
            required : true
        },
        textButton : {
            type : String,
            required : true
        },
        showSVG : {
            type : Boolean,
        },
        noStyle : {
          type: Boolean,
          default : false
        }

    },
    computed:{
        image(){
            if(this.imageUrl != 'svg') return require(`../../../../public/img/icons/${this.imageUrl}`)
        }
    }
};
</script>
<style lang="scss" scoped>
.info-default {
  width: 100%;
  height: 100%;
  background-color: #dbfdfb;
  background-size: cover !important;

  .info-container {
    display: flex;
    flex-direction: column;
    // justify-content: center;
    height: 100%;
    margin: 0 auto;
    width: 80%;

    .image-info {
      // height: 40%;
      // flex: 1;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      padding-top: 30px;

      .container-image {
        display: flex;
        align-items: center;
        justify-content: center;

        .image {
          // height: 180px;
          margin-bottom: 10%;
        }
      }

      .container-white {
        background-color: white;
        width: 250px;
        height: 250px;
        border-radius: 100%;

        .image {
          margin-bottom: 0%;
        }
      }
    }

    .title-white {
      margin-top: -5%;
    }

    .title-info {
      // height: 115px;
      // flex: 1;
      display: flex;
      flex-direction: column;
      text-align: center;
      text-transform: uppercase;
      // line-height: 20px;
      letter-spacing: 0px;
      font-size: 45px;
      align-items: center;


      .small-title {
        text-transform: uppercase;
        font-weight: 900;
        letter-spacing: 4px;
        font-size: 17px;
        border-radius: 300px;
        padding: 5px 32px;    
        margin: 32px 0 20px;
        max-width: 310px;
      }

      .title {
        font-weight: 900;
        line-height: 40px;
      }
			.shadow{
				-webkit-text-fill-color: transparent;
				-webkit-text-stroke-width: 1px;
				// -webkit-text-stroke-color: white;
				position: relative;
				top: -44px;
				left: 2px;
        font-weight: 900;
			}      
    }

    .desc-info {
      // height: 70px;
      width: 85%;
      text-align: center;
      margin: 15px auto;

      .desc {
        font-size: 15px;
        color: rgba(47, 53, 58, 0.541);
        word-spacing: 2px;
        line-height: 15px;
      }
    }

    .button-info {
      width: 80%;
      margin: 10px auto;
      padding-top: 10px;
      display: flex;
      flex-direction: row;
      align-items: baseline;
      max-width: 300px;

      .arrow-right {
        height: 0;
        border-top: 6px solid transparent;
        border-bottom: 6px solid transparent;
        border-left: 6px solid #fff;
        width: 0;
        position: relative;
        right: 33px;
      }      
    }
  }
}
@media screen and (max-width: 750px){
  .container-image{
    width: 60%;
  }
  .info-default {
    .info-container{
      .title-info {
        position: relative;
        .small-title{
          margin: 20px 0 20px;
        }
        .title{
          font-size: 38px;
        }
        .shadow{
          font-size: 38px;
          margin-left: 7px;
          position: absolute;
          top: 88px;
          left: auto;
        }
      }
    }
  }
}
@media only screen and (min-width: 750px) {
  .info-default {
    .info-container {
      padding: 0 150px;
      height: 100%;
      width: auto;
      // .title-info {
      //   height: 10%;
      //   margin-top: -2%;
      // }

      .desc-info {
        // height: 10%;
      }

      .button-info {
        margin-top: 0px;
      }
    }
  }
}
</style>
